import { render, staticRenderFns } from "./146.vue?vue&type=template&id=04c8e5da&scoped=true&"
var script = {}
import style0 from "./146.vue?vue&type=style&index=0&id=04c8e5da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c8e5da",
  null
  
)

export default component.exports